import { createFileRoute, Outlet } from '@tanstack/react-router';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/orders')({
  component: ManagerOrdersRoute,
});

function ManagerOrdersRoute() {
  return (
    <ManagerPortal>
      <Outlet />
    </ManagerPortal>
  );
}
